import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Loader2, AlertCircle } from 'lucide-react';
import { useOutfitStore } from '@/stores/outfitStore';

export const AutoSaveIndicator: React.FC = () => {
  const { t } = useTranslation();
  const { autoSaveStatus } = useOutfitStore();

  if (autoSaveStatus === 'idle') return null;

  return (
    <div className="flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full transition-all animate-spring-in">
      {autoSaveStatus === 'saving' && (
        <>
          <Loader2 className="w-3.5 h-3.5 text-primary animate-spin" />
          <span className="text-muted-foreground italic hidden sm:inline">
            {t('outfit.autosave')}...
          </span>
        </>
      )}

      {autoSaveStatus === 'saved' && (
        <>
          <div className="w-4 h-4 rounded-full bg-emerald-100 flex items-center justify-center">
            <Check className="w-3 h-3 text-emerald-600" strokeWidth={3} />
          </div>
          <span className="text-emerald-600 hidden sm:inline">
            {t('outfit.autosave')}
          </span>
        </>
      )}

      {autoSaveStatus === 'error' && (
        <>
          <AlertCircle className="w-3.5 h-3.5 text-destructive" />
          <span className="text-destructive hidden sm:inline">{t('common.error')}</span>
        </>
      )}
    </div>
  );
};
